export function MenuCTA() {
  return (
    <div className="bg-[#f5f5dc] py-8">
      <div className="container mx-auto px-4 text-center">
        <a
          href="/menu"
          className="inline-block bg-[#d4b08a] hover:bg-[#c09f7b] text-[#8b4513] font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300 shadow-lg hover:shadow-xl border-2 border-[#b8966d]"
        >
          <span>Click Here To Browse The Menu</span>
        </a>
      </div>
    </div>
  );
}